<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">
		
		<div class="">
			<el-form inline ref="form" :model="searchform">

				

					<el-form-item class="mb-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:150px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:100px" ></el-input>
					</el-form-item>
					<el-form-item  class="mb-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
	
		</div>

    <div v-if="this.aid!='soft10'"><span class="text-danger ml-2">{{$t('msg.충전')}}:{{formatMoney(total_money)}}</span><span class="text-primary ml-2">{{$t('msg.환전')}}:{{formatMoney(total_emoney)}}</span><span class="text-success ml-2">{{$t('searchText.차액')}}:{{formatMoney(total_money-total_emoney)}}</span></div>

    <div v-if="this.aid=='soft10'"><span class="text-danger ml-2">{{$t('msg.알충전')}}:{{formatMoney(total_money)}}</span><span class="text-primary ml-2">{{$t('msg.알환전')}}:{{formatMoney(total_emoney)}}</span><span class="text-success ml-2">{{$t('msg.알차액')}}:{{formatMoney(total_money-total_emoney)}}</span>
      <span class="text-danger ml-2">{{$t('searchText.카슬충전')}}:{{formatMoney(total_amoney)}}</span><span class="text-primary ml-2">{{$t('searchText.카슬환전')}}:{{formatMoney(total_aemoney)}}</span><span class="text-success ml-2">{{$t('searchText.카슬차액')}}:{{formatMoney(total_amoney-total_aemoney)}}</span>  <template v-if="this.power=='1'"><span class="text-danger ml-2">{{$t('searchText.파워충전')}}:{{formatMoney(total_pmoney)}}</span><span class="text-primary ml-2">{{$t('searchText.파워환전')}}:{{formatMoney(total_pemoney)}}</span><span class="text-success ml-2">{{$t('searchText.파워차액')}}{{formatMoney(total_pmoney-total_pemoney)}}</span></template></div>
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
        :row-class-name="tableRowClassName"
      style="width: 100%"
      border class="mt-2"  :empty-text="$t('tableText.데이타가없습니다')">
     
    <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*40-scope.$index}}</template>
        </el-table-column>
    
         <el-table-column
        :label="$t('nav.아이디')" prop="mem_id" align="center" width="150">
          <template slot-scope="scope">
            <div :style="{ backgroundColor :scope.row.RaceYN}">
             <span @click="openModel(scope.row.mem_id,'tab1')" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
      :label="$t('tableText.이름')"
        prop="mem_name" align="center">
          <template slot-scope="scope">
            
            <span @click="openLayoutModel(scope)"  style="cursor:pointer"> {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 

       <el-table-column
        :label="$t('searchText.구분')"
       prop="gubun" align="center">
      </el-table-column>

        <el-table-column
        :label="$t('tableText.충환ID')"
       prop="m_cp" align="center">
       <template  slot-scope="scope"><span :class="scope.row.m_cp ===userid ?'text-danger':''">{{ scope.row.m_cp }}
    </span></template>
      </el-table-column>

      <el-table-column
         :label="$t('tableText.금액')" prop="money1" align="center" >
    <template  slot-scope="scope"><span :class="scope.row.m_cp ===userid ?'text-danger':''">{{ scope.row.money1>0 ? formatMoney(scope.row.money1):formatMoney(scope.row.money2)}}
    </span></template>
      </el-table-column>


<template v-if="this.sitetype==2">
      <el-table-column
        :label="$t('tableText.이전이벤트머니')"
        prop="jan" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.jan)}}</template>

      </el-table-column>

        <el-table-column
        :label="$t('tableText.이전게임머니')"
       prop="jan2" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.jan2)}}</template>

      </el-table-column>
</template>

<template v-if=" this.sitetype==1 || this.sitetype==3 || this.sitetype==4 ">
       <el-table-column
        :label="$t('tableText.변동후')"
       prop="jan" align="center">
        <template slot-scope="scope">{{ scope.row.jan2 ? formatMoney(scope.row.jan2):formatMoney(scope.row.jan)}}</template>

      </el-table-column>

     
</template>
     
    
       <el-table-column
        :label="$t('tableText.시간')"
         prop="regdate" align="center">
      </el-table-column>

      <el-table-column
        :label="$t('tableText.메모')"
        prop="memo" align="center">
      </el-table-column>
      

    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
        
         <el-dialog 
          :visible.sync="dialogModel"
          :close-on-click-modal ="false"
          width="25%" style="height: 500px;overflow: hidden;">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
            
            <el-form-item :label="$t('nav.아이디')" class="mb-0">
              <el-input v-model="form.mem_id"  class="w-75"></el-input>
            </el-form-item>
            <el-form-item :label="$t('searchText.구분')" class="mb-0 " >
              <el-select :label="$t('status.선택')" v-model="gubun" class="w-75 typeIco">
                  <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.타입')" class="mb-0 ">
              <el-select placeholder="선택" v-model="io_type" class="w-75 typeIco">
                  <el-option
                  v-for="item in ioType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.금액')" class="mb-0">
              <el-input v-model="form.money" type="number"  class="w-75"></el-input>
            </el-form-item>

             <el-form-item :label="$t('tableText.메모')"class="mb-0">
              <el-input v-model="form.memo" type="text"  class="w-75"></el-input>
            </el-form-item>
         
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="dialogModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="cashSumbit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog> 
				  <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow">
      </div>  
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
 import layerNew from '../../components/common/layer-new.vue';

    export default {
     components: {
      layer,layerNew
    },
    	data(){
    		return{
shareShow:false,
           total_aemoney: '',
          total_amoney: '',

          total_emoney: '',
          total_money: '',
           total_pemoney: '',
          total_pmoney: '',
          gubun:'',
           form:{
            mem_id:'',
            money:'',
            memo:'',
          },
           io_type:'',
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          options1: [{
               
                label:  this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label:  this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }],

           level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")                 
            },
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
            bg:window.sessionStorage.getItem('bg'),
             userid:window.sessionStorage.getItem('userid'),
             aid:window.sessionStorage.getItem('admin_id'),
              power:window.sessionStorage.getItem('power'),
          formLoading:false,
          idDialogVisible: false,
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
		        	label:this.$i18n.t("msg.아이디"),
		        	value:'mem_id'
		        },{
		        	label:this.$i18n.t("msg.닉네임"),
		        	value:'mem_name'
		        }
            ,{
              label:this.$i18n.t("tableText.충환ID"),
              value:'m_cp'
            },

		        ],
		        
		        value:'',
		        


    			},
    			 pickerOptions: {
    			},
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
      
    			
		        
    		
    			total:0,
    			size:0,
    			loading: false,
    			tableData: [],
			    currentPage:1,   
          dialogModel:false,
    			}	
    			
    		},
    		created() {
    			this.getList();

		},
    	
    	methods:{
        openLayoutModel(e){
          this.dialogModel = true
          this.form.mem_id = e.row.mem_id
        },
           // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
             cancelEvent(){
          this.shareShow = false
        },
        cancelData(){
          this.idDialogVisible = false
        }, 
        tableRowClassName({row, rowIndex}) {
     
       if (rowIndex%2 === 1) {
        return 'odd-row-class';
       }
       else{
         return 'edd-row-class';
       }
    },
         openModel(id,e){

          if(this.aid=='soft10')
            {
            this.shareShow = true

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: ['1200px', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;
           }
           
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              
            


    			this.getList();
    			
             

    		},
         cashSumbit(){
          let token=window.sessionStorage.getItem('user');
           this.loading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/admin/cash_event_up',
                    data:{
                      mem_id:this.form.mem_id,
                      money:this.form.money,
                      memo:this.form.memo,
                      gubun:this.gubun,
                      io_type:this.io_type
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.loading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     this.form.mem_id=''
                     this.form.money=''
                     this.form.memo=''
                       this.dialogModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })   
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                  console.log(error)       //请求失败返回的数据
              })
        },
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		   
              

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/moneylist_bak?s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;
    			
    			// if(bm!='')
    			// {
       //            urls=urls+'&search=service_no%3A'+bm+'%3Bphone%3A'+bm+'%3Btoken%3A'+bm+'%3Bmac%3A'+bm;
    			// }
             
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                     console.log('data=',response.data.data.data)
                     this.tableData =response.data.data.data
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money

                     this.total_pemoney = response.data.total_pemoney
                     this.total_pmoney = response.data.total_pmoney

                     this.total_aemoney = response.data.total_aemoney
                     this.total_amoney = response.data.total_amoney


                     this.loading =false
               
            }).catch((error) =>{
            	
                 this.$message.error(error);
              this.loading = false
               
            })
    		},
    		
    		
    
    	
    		
    	}
  }
</script>

 <style scoped>
 

/deep/ .el-form-item {
	margin-bottom:10px;
}
/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }

</style>


// WEBPACK FOOTER //
// src/views/moneybak/list.vue